export const OpenPayment = () => {
  return (
    <div className='text-content-title py-4 text-sm'>
      Neste formato, o cliente informa o valor do pagamento. O mínimo aceito é de R$ 5,00 e o parcelamento não está
      disponível.
    </div>
  );
};
